export const COLORS = {
  primary: '#026440',
  white: '#FFFFFF',
  textPrimary: '#1e272c',
  textSecondary: 'rgba(255, 255, 255, 0.7)',
};

export const APP_STORE_URL = 'https://apps.apple.com/us/app/lookaround-live/id6670697196';
